import { useState, useEffect, useRef } from "react";

const useDebounce = (onDebounce, delay = 500) => {
  const timer = useRef(null);

  return (...args) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      onDebounce(...args);
    }, delay);
  };
};

export default useDebounce;
